import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { EmptyListIcon } from '@systemeio/ui'

interface EmptyListProps {
  small?: boolean
  firstLineRect?: boolean
  footerAdditionalElement?: JSX.Element
}

const EmptyList = ({ small, firstLineRect, footerAdditionalElement }: EmptyListProps) => {
  const { t } = useLocoTranslation()
  return (
    <>
      <div
        className={`flex w-full flex-col items-center justify-center gap-3 ${
          small ? 'py-10' : 'py-20'
        } bg-background-secondary ${firstLineRect ? 'rounded-b-lg' : 'rounded-lg'}`}
      >
        <EmptyListIcon className={small ? 'h-32 w-32' : ''} />
        <div className={`flex flex-col items-center`}>
          <span className={'text-text-primary text-base'}>{t('dashboard.list.empty_title')}</span>
          <span className={'text-text-primary text-base'}>{t('dashboard.list.empty_list')}</span>
        </div>
      </div>
      {footerAdditionalElement && (
        <div className={'mt-3 flex justify-start'}>{footerAdditionalElement}</div>
      )}
    </>
  )
}

export default EmptyList
